import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  RoundCloseIcon,
  Text,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

const HEADER = 'Your bank account could not be verified';
const DESCRIPTION = 'Update banking account information to try again or add a new bank account.';

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
}

export const PlaidVerificationFailedModal: React.FC<Props> = ({
  visible,
  onSetVisible,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <ModalWrapper testId="PlaidVerificationFailedModal" visible={visible} onSetVisible={onSetVisible}>
      <Box align="center" pad={{ vertical: 'spacing24', horizontal: 'spacing48' }}>
        <RoundCloseIcon color="danger" size="48px" />
        <Text
          data-testid="PlaidVerificationFailedModal_modal_header"
          margin={{ vertical: 'spacing12' }}
          textAlign="center"
          size="24px"
          weight={700}
        >
          {t(HEADER)}
        </Text>

        <Text
          data-testid="PlaidVerificationFailedModal_modal_help-text"
          margin={{ bottom: 'spacing24' }}
          textAlign="center"
        >
          {t(DESCRIPTION)}
        </Text>

        <Box direction="row">
          <AppButton
            testId="PlaidVerificationFailedModal_modal_submit"
            onClick={onSubmit}
            width="200px"
          >
            {t('Got It')}
          </AppButton>
        </Box>
      </Box>
    </ModalWrapper>
  );
};
